import { makeEnvironmentProviders } from '@angular/core';
import { BREEZE_ENTITY_REGISTRATION_FUNC, BREEZE_METADATA_TOKEN } from '@mri/breeze-entity';
import {
  Dataset,
  DsgMetadata,
  IdentityPrincipal,
  OrganisationPrincipal,
  OrganisationWorkspace,
  Report,
  ReportInfo,
  TemplateWorkspace,
  UserPrincipal,
  UserRole
} from './models';
import { registerBreezeLibraryFixes } from './models/register-breeze-library-fixes';
import { registerModelConventions } from './models/register-model-conventions';
import { DsgRegistrationHelper } from './models/registration-helper';
import { registerSharedValidators } from './models/shared-validators';
import { testingProviders } from './testing';

export function provideEntityState() {
  return makeEnvironmentProviders([
    testingProviders,
    { provide: BREEZE_METADATA_TOKEN, useValue: DsgMetadata.value },
    // important: make sure registerBreezeLibraryFixes registered very early
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: registerBreezeLibraryFixes, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: registerSharedValidators, multi: true },
    // important: make sure registerModelConventions occurs before entity specific registration functions
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: DsgRegistrationHelper.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: registerModelConventions, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: OrganisationPrincipal.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: UserPrincipal.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: IdentityPrincipal.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: ReportInfo.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: UserRole.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: Dataset.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: Report.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: TemplateWorkspace.register, multi: true },
    { provide: BREEZE_ENTITY_REGISTRATION_FUNC, useValue: OrganisationWorkspace.register, multi: true }
  ]);
}
